module.exports = __webpack_public_path__ + "img/e7cc1c5.png";